import store from '../store'

// async function error(descritpion) {
//   await store.commit('notification/toast', {
//     type: 'error',
//     message: 'ผิดพลาด',
//     description: descritpion || 'กรอกข้อมูลให้ครบถ้วน'
//   })
//   await store.commit('notification/toastShow', {})
// }

// async function success(descritpion) {
//   await store.commit('notification/toast', {
//     type: 'success',
//     message: 'สำเร็จ',
//     description: descritpion || 'บันทึกข้อมูล'
//   })
//   await store.commit('notification/toastShow', {})
// }

async function error(descritpion) {
  await store.commit('notification/toastError', {
    message: 'ผิดพลาด',
    description: descritpion || 'กรอกข้อมูลให้ครบถ้วน'
  })
  await store.commit('notification/toastErrorShow', {})
}

async function success(descritpion) {
  await store.commit('notification/toastSuccess', {
    message: 'สำเร็จ',
    description: descritpion || 'บันทึกข้อมูล'
  })
  await store.commit('notification/toastSuccessShow', {})
}

function validatorShow(validators) {
  const msgErrors = []
  for (const i in validators) {
    msgErrors.push(validators[i][0])
  }
  error(msgErrors.join('<br>'))
}
export default {
  error,
  success,
  validatorShow
}
